import './style.scss';

export function industries_block() {
    const block = document.querySelector('.industries_block');
    if (!block) return;

}
